module.exports = __webpack_public_path__ + "img/text_large.d3fa6ec9.png";